import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { subirGestorCapas } from '../../models/GestorCapas';
import { GestorCapasService } from '../services/gestorCapas/gestorCapas.service';

const initialState = {};

const gestorCapasService = new GestorCapasService();
export const gestorCapasSlice = createSlice({
  name: 'gestor_capas',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
  },
});

//se incluyen estas funciones en el slice ya que todos los llamados de los endpoints se manejan a traves de redux
export const getListCapasCatastroMinero = createAsyncThunk('get_list_capas_catastro_minero', async () => {
  return gestorCapasService.getListCapasCatastroMinero() 
});

export const uploadCapasCatastroMineroOrAuxiliares = createAsyncThunk('post_capas_catastro_minero_or_auxiliares', async (capas: subirGestorCapas) => {
    return gestorCapasService.uploadCapasCatastroMineroOrAuxiliares(capas) 
});

export const getLastUpdateLayersCM = createAsyncThunk('get_last_update_layers_cm', async () => {
  return gestorCapasService.getLastUpdateLayersCM() 
});


export default gestorCapasSlice.reducer;
